import style from "./SIT.module.css";
import { Button as GetiButton } from "@geti/identidade-visual-react";
import { isLoggedIn } from "../../Auth/auth";

const SIT: React.FC = () =>{
    const handleButton = () =>{
        window.open('http://sit.defensoria.sc.def.br/front/helpdesk.public.php?create_ticket=1', '_blank');
    }

    return(<> 
       {isLoggedIn() && <GetiButton onClick={handleButton} className={style.button}><b>SIT</b></GetiButton>}
    </>)
}

export default SIT;